import Fallback from "app/components/Fallback";
import React from "react";

const TextSMS = React.lazy(() =>
  import("app/modules/schools/pages/Communication/TextSms/TextSMS")
);
const WhatsappTemplates = React.lazy(() =>
  import("app/modules/schools/pages/Communication/WhatsappTemplates")
);

export const TextSMSPage = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <TextSMS {...props} />
  </React.Suspense>
);

export const WhatsappTemplatePage = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <WhatsappTemplates {...props} />
  </React.Suspense>
);